<template>
  <div>
    <div class="top">
      <div class="top-breadcrumbs">
        <div class="left-crumbs-wrapper">
          <div @click="
            goTo(
              $store.state.paginacija.back_link != ''
                ? $store.state.paginacija.back_link
                : '#'
            )
            " :class="'privremeni-breadcrumb'">
            {{ this.$store.state.paginacija.title }}
          </div>
          <div class="current-breadcrumb" v-for="(page, key) in $store.state.paginacija.subpages" :key="key">
            {{ page }}
          </div>
        </div>
        <div class="mobile-menu-wrapper" @click="toggleSide()">
          <div class="mobile-menu">
            <input type="checkbox" />
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
      <NotificationComponent :sioVar="sioVar" v-if="visibility_controll" />
      <div class="top-search" v-if="visibility_controll">
        <div class="top-search-field">
          <input type="text" @keydown.esc="srch_txt = ''" :placeholder="$t('components.nav_top.srch.placeholder')"
            v-model="srch_txt" />
        </div>
        <div class="top-search-right-wrapper">
        <CustomDropdown  :id="'drop-top-search'" :additional_classes="'top-search-group'" :custom_icon="1" v-model="search_filter"
                    :drop_items="drop_items" /> 
        <!-- <div class="top-search-group">
          <select class="drop-filter" id="search-group" v-model="search_filter">
            <option v-for="(single, key) in drop_items" :key="key" :value="single.id" :disabled="!single.visible">
              {{ single.naziv }}
            </option>
          </select>
          <div class="search-group-arrow"></div>
        </div> -->
        <div class="top-search-button">
          <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
            <g>
              <g>
                <path fill="#fff"
                  d="M25.714 25.714a.952.952 0 0 1-1.346 0l-6.295-6.295A10.95 10.95 0 0 1 11 21.999C4.925 22 0 17.076 0 11 0 4.926 4.925 0 11 0s11 4.926 11 11c0 2.696-.972 5.161-2.581 7.074l6.295 6.295a.952.952 0 0 1 0 1.346zM20 11a9 9 0 1 0-18 0 9 9 0 0 0 18 0z" />
              </g>
            </g>
          </svg>
        </div>
        </div>
      </div>
      <div class="top-right">
        <div class="top-notifications" v-if="visibility_controll">
          <!-- <select class="top-tasks lang" v-model="selected_lang" @change="changeLanguage($event)">
            <option class="top-tasks" value="hr">hr</option>
            <option class="top-tasks" value="en">en</option>
          </select> -->
          <!-- Email Client Button -->
          <div class="top-tasks top-email" @click="openEmailClient()" :title="$t('components.nav_top.email_tooltip')">
            <div class="top-tasks-no email-animation" v-if="unread_email_count > 0">{{ unread_email_count > 99 ? '99+' : unread_email_count }}</div>
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="18" viewBox="0 0 24 18">
              <g>
                <g>
                  <path fill="#2b2b41" d="M21.6 0H2.4C1.08 0 0 1.012 0 2.25v13.5C0 16.988 1.08 18 2.4 18h19.2c1.32 0 2.4-1.012 2.4-2.25V2.25C24 1.012 22.92 0 21.6 0zm0 2.25v1.969c-1.116.881-2.892 2.25-6.696 5.156-.84.647-2.508 2.213-2.904 2.188-.396.025-2.064-1.541-2.904-2.188C5.292 6.469 3.516 5.1 2.4 4.219V2.25h19.2zm-19.2 13.5V7.172c1.14.89 2.76 2.133 5.22 4.007 1.128.87 3.108 2.759 4.38 2.759 1.26 0 3.216-1.856 4.38-2.759 2.46-1.874 4.08-3.116 5.22-4.007v8.578H2.4z"/>
                </g>
              </g>
            </svg>
          </div>
          <TasksDropdown ref="taskDrop" :sioVar="sioVar" />
          <NotificationDropdown ref="sysDrop" :sioVar="sioVar" />
          <!-- <div class="top-alarms">
            <div class="top-alarms-no">0</div>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="25" viewBox="0 0 20 25">
              <g>
                <g>
                  <path fill="#2b2b41"
                    d="M19.279 20.842a2.778 2.778 0 0 1-2.164 1.04h-4.294c0 1.59-1.261 2.882-2.812 2.882-1.55 0-2.812-1.293-2.812-2.881H2.885c-.84 0-1.628-.38-2.164-1.04a2.926 2.926 0 0 1-.6-2.373c.324-1.772.965-2.92 1.53-3.933.574-1.029 1.028-1.841 1.028-3.12v-1.44c0-3.785 2.79-6.952 6.374-7.429V1.142c0-.53.42-.96.938-.96s.937.43.937.96v1.403a7.177 7.177 0 0 1 4.27 2.176 7.546 7.546 0 0 1 2.105 5.255v1.44c0 .974.263 1.662.717 2.52a.972.972 0 0 1-.379 1.302.915.915 0 0 1-.445.116.934.934 0 0 1-.825-.504c-.456-.862-.943-1.91-.943-3.433v-1.44c0-3.029-2.395-5.526-5.34-5.57h-.177c-2.955.044-5.358 2.541-5.358 5.57v1.44c0 1.789-.648 2.95-1.274 4.073-.516.924-1.05 1.88-1.316 3.334a.966.966 0 0 0 .2.792c.106.13.339.347.722.347h14.23a.917.917 0 0 0 .721-.347.966.966 0 0 0 .2-.792.959.959 0 0 1 .75-1.121.939.939 0 0 1 1.093.767 2.926 2.926 0 0 1-.6 2.372zm-8.332 1.04H9.07c0 .53.421.961.938.961a.95.95 0 0 0 .938-.96z" />
                </g>
              </g>
            </svg>
          </div> -->
        </div>
        <div class="top-user" id="dropdown-identificator" @click="isOpenDropDown = !isOpenDropDown">
          <!-- <div  class="top-user" id="dropdown-identificator"> -->
          <div class="top-username">{{ user.account.name }}</div>
          <div class="top-user-dropdown downarrow"></div>
          <div class="top-user-img" :style="avatar_class" v-if="avatar_class != null"></div>
          <div class="top-user-img-initials" v-else>{{ user.account.name.split(" ")[0][0] + user.account.name.split(" ")[1][0] }}</div>
        </div>
        <div class="top-user-menu">
          <div class="top-menu-top">
            <div @click="openUserDetails()" class="top-menu-img" :style="avatar_class" v-if="avatar_class != null"></div>
            <div class="top-user-img-initials" v-else>{{ user.account.name.split(" ")[0][0] + user.account.name.split(" ")[1][0] }}</div>
            <div class="user-menu1">
              <div @click="openUserDetails()" class="menu-top-username">
                {{ user.account.name }}
              </div>
              <div class="top-menu-mail" @click="main_email_visible = true; isOpenDropDown = false;">{{
                user.account.username }}</div>
              <!-- <email-response :file_list="[]" :username_btn="user.account.username"/> -->
            </div>
          </div>
          <div class="user-menu2">
            <div>
              <a @click="openUserDetails()">{{
                $t("components.nav_top.avatar.l1")
                }}</a>
            </div>
            <div>
              <a @click="openProfile()">{{
                $t("components.nav_top.avatar.l2")
                }}</a>
            </div>
            <div v-if="admin_panel_acces">
              <a @click="openAdmin()">{{
                $t("components.nav_top.avatar.l3")
                }}</a>
            </div>
            <label for="upload" class="uredi-sliku">
              <div class="top-menu-settings">
                {{ $t("components.nav_top.avatar.l4") }}
              </div>
              <input type="file" id="upload" accept=".jpeg" style="display: none" ref="file" @change="avatarChange()" />
            </label>
            <div class="odjava">
              <a @click="fullLogout()">{{
                $t("components.nav_top.avatar.l5")
                }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end class top -->
    <div class="dropdown-search-wrapper">
      <div class="dropdown_search" v-if="srch_txt != ''">
        <div class="search-row-center" v-if="nothingToShow">
          {{ $t("components.nav_top.srch.nothing") }}
        </div>
        <div class="search-title-wrapper" v-if="this.srch_predmeti != '' || this.srch_spisi != ''">
          <div class="search-title">{{ $t("components.nav_top.srch.h1") }}</div>
        </div>
        <div v-for="predmet in srch_predmeti" :key="predmet.group_url + '/predmet'" class="search-row"
          @click="closeDrop">
          <router-link :to="'/case/' + predmet.group_url + '/'" class="search-result">
            <div>
              <span class="search-label-wrapper">
                <span class="search-label"><img class="search-icon" src="@/assets/img/search-predmet-icon.svg" />{{
                  $t("components.nav_top.srch.s1_1") }}</span>
              </span>
              {{ predmet.ime_predmeta }}
            </div>
          </router-link>
        </div>

        <!-- Spisi -->
        <div v-for="(spisi, key) in srch_spisi" :key="'300' + key">
          <div v-for="spis in spisi" :key="spis.id_spis + '/spisi'" class="search-row" @click="closeDrop">
            <router-link :to="'/case/' + spis.case_id + '/spisi/' + spis.id_spis" class="search-result">
              <span class="search-label-wrapper">
                <span class="search-label"><img class="search-icon" src="@/assets/img/search-spis-icon.svg" />{{
                  $t("components.nav_top.srch.s1_2") }}</span>
              </span>
              {{ spis.ime }}
              <!-- - <span class="search-label-imespisa">{{ spis.ime_predmeta}}</span> -->
            </router-link>
          </div>
        </div>
        <div class="search-title-wrapper" v-if="this.srch_projects != ''">
          <div class="search-title">{{ $t("components.nav_top.srch.h2") }}</div>
        </div>
        <div v-for="proj in srch_projects" :key="proj.group_url + '/project'" class="search-row" @click="closeDrop">
          <router-link :to="'/projects/' + proj.group_url + '/'" class="search-result">
            <div>
              <span class="search-label-wrapper">
                <span class="search-label"><img class="search-icon" src="@/assets/img/search-predmet-icon.svg" />{{
                  $t("components.nav_top.srch.s2") }}</span>
              </span>
              {{ proj.name }}
            </div>
          </router-link>
        </div>

        <div class="search-title-wrapper" v-if="
          res_osobe != '' &&
          (res_osobe.res_fiz.length != 0 ||
            res_osobe.res_institucije.length != 0 ||
            res_osobe.res_odvjetnici.length != 0 ||
            res_osobe.res_pravna.length != 0 ||
            res_osobe.res_sluzbene.length != 0)
        ">
          <div class="search-title">{{ $t("components.nav_top.srch.h3") }}</div>
        </div>
        <!-- fiz_osobe -->
        <div v-for="osoba in res_osobe.res_fiz" :key="'/osobe/fiz/' + osoba.uid" class="search-row" @click="closeDrop">
          <router-link :to="'/osobe/fiz/' + osoba.uid">
            <span class="search-label-wrapper">
              <span class="search-label">{{ osoba.status }}</span>
            </span>
            {{ osoba.ime }} {{ osoba.prezime }}
          </router-link>
        </div>
        <!--pravne osobe  -->
        <div v-for="osoba in res_osobe.res_pravna" :key="'/osobe/prav/' + osoba.uid" class="search-row"
          @click="closeDrop">
          <router-link :to="'/osobe/prav/' + osoba.uid">
            <span class="search-label-wrapper">
              <span class="search-label">{{ osoba.status }}</span>
            </span>
            {{ osoba.ime }}
          </router-link>
        </div>
        <!-- odvjetnici -->
        <div v-for="osoba in res_osobe.res_odvjetnici" :key="'/osobe/law/' + osoba.uid" class="search-row"
          @click="closeDrop">
          <router-link :to="'/osobe/law/' + osoba.uid">
            <span class="search-label-wrapper">
              <span class="search-label">{{
                $t("components.nav_top.srch.s3_1")
                }}</span>
            </span>
            {{ osoba.ime }} {{ osoba.prezime }}
          </router-link>
        </div>
        <!-- sluzbene -->
        <div v-for="osoba in res_osobe.res_sluzbene" :key="'/osobe/leg-body/' + osoba.uid" class="search-row"
          @click="closeDrop">
          <router-link :to="'/osobe/leg-body/' + osoba.uid">
            <span class="search-label-wrapper">
              <span class="search-label">{{
                $t("components.nav_top.srch.s3_2")
                }}</span>
            </span>
            {{ osoba.ime }} {{ osoba.prezime }}
          </router-link>
        </div>
        <!-- institucije -->
        <div v-for="inst in res_osobe.res_institucije" :key="'osobe/institucije/' + inst.uid" class="search-row"
          @click="closeDrop">
          <router-link :to="'osobe/institucije/' + inst.uid">
            <span class="search-label-wrapper">
              <span class="search-label">{{
                $t("components.nav_top.srch.s3_3")
                }}</span>
            </span>
            {{ inst.naziv }}
          </router-link>
        </div>

        <!--events  -->
        <div class="search-title-wrapper" v-if="this.srch_events_list.length != ''">
          <div class="search-title">{{ $t("components.nav_top.srch.h4") }}</div>
        </div>
        <div v-for="event in srch_events_list" :key="'/case/' + event.uid + '/kalendar'" class="search-row"
          style="cursor: pointer" @click="openEventDetails(event)">
          <!-- <router-link :to="'/case/' +event.predmet.group_url+ '/kalendar'"> -->
          <span class="search-label-wrapper">
            <span :class="[
              'search-label',
              'vrsta-eventa',
              'event-' + event.event_type.class_colour,
            ]">{{ event.event_type.name }}</span>
          </span>
          <span>
            {{ event.title }}
          </span>
          <!-- </router-link> -->
        </div>
        <div v-for="(event, key) in srch_events_list_private" :key="key" class="search-row"
          @click="openEventDetails(event)">
          <!-- <router-link :to="'/case/' +event.predmet.group_url+ '/kalendar'"> -->
          <span class="search-label-wrapper">
            <span :class="[
              'search-label',
              'vrsta-eventa',
              'event-' + event.event_type.class_colour,
            ]">{{ event.event_type.name }}</span>
          </span>
          <span>
            {{ event.title }}
          </span>
          <!-- </router-link> -->
        </div>
        <div v-if="isAnythingLoading" class="search-row">
          <div class="search-loader-dots">
            <div class="search-loader-dot"></div>
            <div class="search-loader-dot"></div>
            <div class="search-loader-dot"></div>
          </div>
        </div>
        <div class="search-title-wrapper" v-if="this.sp_res.length > 0">
          <div class="search-title" v-if="search_filter == '7'">
            {{ $t("components.nav_top.srch.s4_1") }}
            <span class="case-num">{{ getCaseNumber }}</span>
          </div>
          <div class="search-title" v-else-if="search_filter == '8'">
            {{ $t("components.nav_top.srch.s4_2") }}
            <span class="case-num">{{ getProjNumber }}</span>
          </div>
          <div class="search-title" v-else>
            {{ $t("components.nav_top.srch.s4_3") }}
          </div>
        </div>

        <!-- sharepoint res -->
        <div v-for="(sp, key) in sp_res" :key="'100' + key" class="search-row" @click="closeDrop">
          <a :href="sp.resource.webUrl" target="blank" class="search-file-wrapper">
            <div class="search-file-left">
              <img class="search-icon-file search-icon-pdf" :src="returnFileType(sp.resource.name)" />
            </div>
            <div class="search-file-right">
              <div class="file-title">{{ sp.resource.name }}</div>
              <div class="summary" v-if="sp.summary != undefined" v-html="sp.summary"></div>
            </div>
          </a>
        </div>
      </div>
      <!-- end dropdown search -->
    </div>
    <CalendarModal v-if="this.$store.state.event_details.popup_open" :se="this.$store.state.event_details.chosen_event">
    </CalendarModal>
    <main-email-component v-if="main_email_visible" @close="main_email_visible = false" @emailRead="emails_read_in_session = true" />

    <!-- end dropdown search wrapper-->
  </div>
</template>

<script>
import auth from "@/services/auth.js";
import { signOut } from "@/services/auth/redirectLogin";
import person from "@/apiCallers/promise_handler_db/person";
import sharepoint_manager from "@/apiCallers/promise_handler_db/sharepoint";
import predmet_handler from "@/apiCallers/promise_handler_db/predmeti";
import project_handler from "@/apiCallers/promise_handler_db/projects";
import osobe_handler from "@/apiCallers/promise_handler_db/osobe_pr";
import CalendarModal from "@/components/calendarComponents/CalendarModal.vue";
import NotificationComponent from "@/components/generalComponents/NotificationComponent.vue";
import TasksDropdown from "@/components/generalComponents/TasksDropdown.vue";
import $ from "jquery";
import gsap from "gsap";
import moment from "moment";
import CustomDropdown from "@/components/generalComponents/CustomDropdown.vue";
import NotificationDropdown from "../NotificationDropdown.vue";
import graph from "../../../services/graph";
// import EmailResponse from '../../email/EmailResponse.vue';
import MainEmailComponent from '../../email/MainEmailComponent.vue';

export default {
  components: {
    CalendarModal,
    NotificationComponent,
    TasksDropdown,
    CustomDropdown,
    NotificationDropdown,
    // EmailResponse,
    MainEmailComponent,
  },
  props: {
    user: {
      type: Object,
      required: true,
      default: null,
    },
    sioVar: {
      type: Object,
      required: false,
      default: null,
    },
  },

  computed: {
    getCaseNumber() {
      return this.$store.state.current_selected_case.broj_predmeta;
    },
    getProjNumber() {
      return this.$store.state.current_selected_proj.broj_projekta;
    },
    isAnythingLoading() {
      return (
        this.loading_files ||
        this.loading_cases ||
        this.loading_events ||
        this.loading_persons ||
        this.loading_projects
      );
    },
    nothingToShow() {
      return (
        !this.isAnythingLoading &&
        this.srch_predmeti == "" &&
        this.srch_projects.length == 0 &&
        (this.srch_spisi == "") & (this.srch_events_list.length == "") &&
        this.sp_res.length == 0 &&
        (this.res_osobe == "" ||
          (this.res_osobe.res_fiz.length == 0 &&
            this.res_osobe.res_institucije.length == 0 &&
            this.res_osobe.res_odvjetnici.length == 0 &&
            this.res_osobe.res_pravna.length == 0 &&
            this.res_osobe.res_sluzbene.length == 0))
      );
    },
  },
  watch: {
    $route(to) {
      if (to.fullPath.startsWith("/case/")) {
        this.search_filter = "7";
        this.drop_items[6].visible = true;
      } else if (
        to.fullPath.startsWith("/projects/") &&
        to.params.uid != undefined
      ) {
        this.search_filter = "8";
        this.drop_items[6].visible = false;
        this.drop_items[7].visible = true;
      } else {
        this.search_filter = "1";
        this.drop_items[6].visible = false;
        this.drop_items[7].visible = false;
      }
    },
    user: function () {
      console.log(this.user.account);
      if (this.user.account != undefined) {
        this.shortened_name =
          this.user.account.name.split(" ")[0][0] +
          "" +
          this.user.account.name.split(" ")[1][0];
      }
    },
    sioVar: async function () {
      const avatar_url = await graph.getPhoto();
      if (avatar_url) {
        console.log("Avatar url", avatar_url);
        this.avatar_class = {
          backgroundImage: "url(" + avatar_url + ")",
        };
      }else{
        console.log("No avatar url");
        avatar_class = null;
        //name surname initials
        // this.avatar_class = {
        //   backgroundImage: "url(" + this.user.account.name.split(" ")[0][0] + this.user.account.name.split(" ")[1][0] + ".jpeg)",
        // };
      }
      if (this.sioVar != null) {

        console.log(this.$store.state, "store state");
        this.visibility_controll =
          !this.$store.state.logged_in_user.user_role.light_ui;
        this.sioVar.socket.on("connection message", (data) => {
          console.log("Got connection data", data);
        });
        this.admin_panel_acces =
          this.$store.state.logged_in_user.admin_panel_acces;

        this.sioVar.socket.on("new notification", (data) => {
          this.notifications.push(data);
          console.log("New notification", data);
          let notifi = new Notification("Nova obavijest sustava", {
            body: data.title,
            silent: false,
            icon: require("@/assets/novi-crveni-legal.svg"),
            badge: require("@/assets/novi-crveni-legal.svg"),
            timestamp: Math.floor(Date.now()),
          });

          notifi.notificationclick = (event) => {
            event.preventDefault(); // prevent the browser from focusing the Notification's tab
            this.redirectToUrl(data.link);
          };

          setTimeout(() => {
            gsap.fromTo(
              ".notif-" + data.uid,
              0.5,
              { x: 80, opacity: 0 },
              { x: 0, opacity: 1 }
            );
          }, 500);
        });
      }
    },
    isOpenDropDown: function () {
      if (!this.isOpenDropDown) {
        gsap.to(".top-user-dropdown", 0, { transform: "rotate(135deg)" });
        let tl = gsap.timeline();
        tl.fromTo(".top-user-menu", 0.3, { y: 0 }, { y: -20, opacity: 0 });

        tl.to(".top-user-menu", 0, { display: "none" });
        if (
          !this.$refs.taskDrop.isOpenTaskDrop &&
          !this.$refs.sysDrop.isOpenTaskDrop
        ) {
          gsap.to(".router-wrapper", 0.5, {
            filter: "none",
            pointerEvents: "auto",
            opacity: 1,
          });
        }
      } else {
        gsap.to(".top-user-dropdown", 0, { transform: "rotate(-45deg)" });
        let tl = gsap.timeline();
        tl.to(".top-user-menu", 0, { display: "block" });
        tl.fromTo(".top-user-menu", 0.3, { y: -20 }, { y: 0, opacity: 1 });
        gsap.to(".router-wrapper", 0.5, {
          filter: "blur(5px)",
          pointerEvents: "none",
          opacity: 0.5,
        });
      }
    },
    search_filter: function () {
      if (this.srch_txt.trim() != "") {
        this.full_Search_activation();
        if (this.srch_txt == "") {
          this.search_open = false;
        } else {
          this.search_open = true;
        }
      }
    },
    srch_txt: function () {
      this.full_Search_activation();
      if (this.srch_txt == "") {
        this.search_open = false;
      } else {
        this.search_open = true;
      }
    },
    main_email_visible: function (newVal, oldVal) {
      // Refresh unread count when email client is closed AND emails were read
      if (oldVal === true && newVal === false && this.emails_read_in_session) {
        this.fetchUnreadEmailCount();
      }
    },
  },
  methods: {
    // changeLanguage(ev) {
    //   localStorage.setItem("lang", ev.target.value);
    //   window.location.reload();
    // },
    setupExitConfirmation() {
      window.addEventListener("beforeunload", this.confirmExit);
    },
    confirmExit(event) {
      if (!this.$store.state.is_intentional_reload) {
        event.preventDefault();
        event.returnValue = ""; // This is required for Chrome
        return "Izmjene koje ste izvršili možda neće biti pohranjene."; // This will display the confirmation dialog
      }
      this.$store.state.is_intentional_reload = false;
    },
    toggleSide: function () {
      $(".navigation").toggleClass("opened");
    },

    openUserDetails() {
      this.$router.push("/osobe/law/" + this.$store.state.logged_in_user.uid);
      this.isOpenDropDown = false;
    },
   
    isFullUi() {
      if (this.$store.state.logged_in_user != undefined) {
        console.log(this.$store.state.logged_in_user.user_role.light_ui);
        return this.$store.state.logged_in_user.user_role.light_ui;
      } else {
        return false;
      }
      // console.log(this.$store.state.logged_in_user.user_role,"light ui ")
      // return true
    },
    async avatarChange() {
      //check all the inserted files and remove all that don't comply with pdf format START
      let tmp_file_list = [...this.$refs.file.files];
      const formData = new FormData();
      for (const i of Object.keys(tmp_file_list)) {
        formData.append("avatar", tmp_file_list[i]);
      }

      formData.append("uid", this.$store.state.logged_in_user.uid);


    },
    async search_activation() {
      switch (this.search_filter) {
        case "1":
          this.authToken = this.$store.state.aToken;
          this.loading_files = true;
          this.loading_persons = true;
          this.loading_cases = true;
          this.loading_events = true;
          this.loading_projects = true;
          this.srch_all();
          break;
        case "2":
          this.loading_files = false;
          this.loading_persons = false;
          this.loading_cases = true;
          this.loading_events = false;
          this.loading_projects = false;
          this.srch_predmet_spis();
          break;
        case "3":
          this.authToken = this.$store.state.aToken;
          this.loading_files = true;
          this.loading_persons = false;
          this.loading_cases = false;
          this.loading_events = false;
          this.loading_projects = false;
          this.srch_sharepoint();
          break;
        case "4":
          this.loading_files = false;
          this.loading_persons = true;
          this.loading_cases = false;
          this.loading_events = false;
          this.loading_projects = false;
          this.srch_osobe();
          break;
        case "5":
          this.loading_files = false;
          this.loading_persons = false;
          this.loading_cases = false;
          this.loading_events = true;
          this.loading_projects = false;
          this.srch_events();
          break;
        case "6":
          this.loading_files = false;
          this.loading_persons = false;
          this.loading_cases = false;
          this.loading_events = false;
          this.loading_projects = true;
          this.search_projects();
          break;
        case "7":
          this.authToken = this.$store.state.aToken;
          this.loading_files = true;
          this.loading_persons = false;
          this.loading_cases = false;
          this.loading_events = false;
          this.loading_projects = false;
          this.srch_group_documents();
          break;
        case "8":
          this.authToken = this.$store.state.aToken;
          this.loading_files = true;
          this.loading_persons = false;
          this.loading_cases = false;
          this.loading_events = false;
          this.loading_projects = false;
          this.srch_group_documents();
          break;
      }
    },
    full_Search_activation() {
      this.sp_res = [];
      this.srch_spisi = [];
      this.srch_predmeti = [];
      this.srch_projects = [];
      this.srch_events_list = [];
      this.srch_events_list_private = [];
      this.res_osobe = [];
      //vrati search na mjesto
      if (this.srch_txt == "") {
        gsap.to(".top .top-search", 0, {
          left: "27%",
          right: "initial",
          margin: "initial",
          maxWidth: "initial",
        });
        if (
          window.matchMedia("(min-width: 1199px) and (max-width: 1570px)")
            .matches
        ) {
          gsap.to(".top .top-search", 0, {
            left: "30%",
            right: "initial",
            margin: "initial",
            maxWidth: "initial",
          });
        }
        gsap.to(".router-wrapper, .top-breadcrumbs, .top-right", 0.5, {
          filter: "none",
          pointerEvents: "auto",
          opacity: 1,
        });
        gsap.to(".dropdown_search", 0, { zIndex: "-1" });
      } else {
        this.loading_files = true;
        this.loading_persons = true;
        this.loading_cases = true;
        this.loading_events = true;
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.search_activation();
        }, 1000);

        //pomakni search
        gsap.to(".top .top-search", 0, {
          left: "0",
          right: "0",
          margin: "auto",
          maxWidth: "63rem",
        });
        // gsap.to(".top-search-field", 0, {
        //   width: "calc(70%)" // Adjust this value as needed
        // });
        // gsap.to(".top-search-field input", 0, {
        //   width: "100%" // Adjust this value as needed
        // });
        setTimeout(() => {
          gsap.to(".dropdown_search", 0, { zIndex: "999" });
        }, 100);
        gsap.to(".router-wrapper, .top-breadcrumbs, .top-right", 0.5, {
          filter: "blur(5px)",
          pointerEvents: "none",
          opacity: 0.2,
        });
      }
    },
    returnFileType(file_name) {
      var idx_ext = file_name.split(".").length - 1;
      var extension = file_name.split(".")[idx_ext].toLowerCase();
      var return_val = require("@/assets/img/doc_icon.svg");
      switch (extension) {
        case "docx":
          return_val = require("@/assets/img/doc_icon.svg");
          break;
        case "dotx":
          return_val = require("@/assets/img/doc_icon.svg");
          break;
        case "dotm":
          return_val = require("@/assets/img/doc_icon.svg");
          break;
        case "pptx":
          return_val = require("@/assets/img/ppt-icon.png");
          break;
        case "ppt":
          return_val = require("@/assets/img/ppt-icon.png");
          break;
        case "doc":
          return_val = require("@/assets/img/doc_icon.svg");
          break;
        case "pdf":
          return_val = require("@/assets/img/pdf_icon.svg");
          break;
        case "csv":
          return_val = require("@/assets/img/xls_icon.svg");
          break;
        case "xlsx":
          return_val = require("@/assets/img/xls_icon.svg");
          break;
        case "jpg":
          return_val = require("@/assets/img/jpg_icon.svg");
          break;
        case "jpeg":
          return_val = require("@/assets/img/jpg_icon.svg");
          break;
        case "png":
          return_val = require("@/assets/img/png_icon.svg");
          break;
        case "folder":
          return_val = require("@/assets/img/folder_yellow.svg");
          break;
        default:
          return_val = require("@/assets/img/dat_icon.svg");
          break;
      }
      return return_val;
    },
    closeDrop() {
      this.srch_txt = "";
    },
    openEventDetails(event) {
      this.closeDrop();
      this.$store.state.event_details.popup_open = true;
      this.$store.state.event_details.chosen_event = event;
    },
    srch_all() {
      this.search_projects();
      this.srch_predmet_spis();
      this.srch_osobe();
      this.srch_sharepoint();
      this.srch_events();
    },
    srch_predmet_spis() {
      predmet_handler.searchPredmeti(this.srch_txt).then((resp) => {
        this.srch_spisi = resp.data.res_spisi;
        this.srch_predmeti = resp.data.res_predmeti;
        this.loading_cases = false;
      });
    },
    search_projects() {
      project_handler.searchProjects(this.srch_txt).then((resp) => {
        this.srch_projects = resp.data;
        // this.srch_spisi = resp.data.res_spisi;
        // this.srch_predmeti = resp.data.res_predmeti;
        this.loading_projects = false;
      });
    },
    srch_osobe() {
      // console.log("Pretražuje");
      osobe_handler.searchAll(this.srch_txt).then((resp) => {
        // console.log(resp.data);
        this.res_osobe = resp.data;
        this.loading_persons = false;
      });
    },
    srch_events() {
      // console.log("Pretražuje");
      person
        .getSearchEvents(this.$store.state.logged_in_user.uid, this.srch_txt)
        .then((resp) => {
          this.srch_events_list = resp.data.events_case;
          this.srch_events_list_private = resp.data.personal_events;
          this.loading_events = false;
        });
    },
    srch_group_documents: function () {
      console.log("Pretraga dokumenata", this.$route.params.uid);
      graph
        .searchFilesInGroup(this.$route.params.uid, this.srch_txt)
        .then((resp) => {
          console.log(resp.value);

          this.sp_res = resp.value.map((resp) => ({ resource: resp }));
          this.loading_files = false;
        });
    },
    srch_sharepoint() {
      // if(this.$store.state.current_selected_case.group_url != undefined )
      // if(this.$router)
      if (this.$route.fullPath.startsWith("/case/")) {
        graph
          .searchFilesInGroup(this.$route.params.uid, this.srch_txt)
          .then((resp) => {
            console.log(resp.value);

            this.sp_res = resp.value.map((resp) => ({ resource: resp }));
            this.loading_files = false;
          });
      } else {
        sharepoint_manager
          .searchDriveItems(this.authToken, this.srch_txt)
          .then((resp) => {
            if (resp.data.value[0].hitsContainers[0].total > 0) {
              resp.data.value[0].hitsContainers[0].hits.forEach((p) => {
                p.summary = p.summary
                  .replace(/\<c0\>/g, '<span class="highlight">')
                  .replace(/\<\/c0\>/g, "</span>");
                this.sp_res.push(p);
              });
            }
            this.loading_files = false;
          });
      }
    },
    getSatiEvent(fullDateTime) {
      return moment(fullDateTime).format("LT");
    },
    closeNotif(notif_uid) {
      // console.log(notif_uid);
      // gsap.fromTo('.notif-'+notif_uid, 0.5,{x:0, opacity:1},{x:80, opacity:0})
      this.notifications = this.notifications.filter(
        (not) => not.uid != notif_uid
      );
    },
    fullLogout() {
      signOut();
    },
    openProfile() {
      this.isOpenDropDown = !this.isOpenDropDown;
      this.$router.push("/personal-profile");
    },

    openAdmin() {
      this.isOpenDropDown = !this.isOpenDropDown;
      this.$router.push("/admin");
    },
    goTo(link) {
      this.$router.push(link);
    },
    async fetchUnreadEmailCount() {
      // Skip if tab is not visible or already fetching
      if (document.hidden || this.is_fetching_email_count) {
        return;
      }
      this.is_fetching_email_count = true;
      try {
        const count = await graph.getUnreadEmailCount();
        this.unread_email_count = count;
      } catch (e) {
        console.error('Error fetching unread email count:', e);
      } finally {
        this.is_fetching_email_count = false;
      }
    },
    openEmailClient() {
      this.main_email_visible = true;
      this.emails_read_in_session = false;
    },
  },
  data() {
    // const lang = localStorage.getItem("lang") || "hr"
    return {
      // selected_lang: lang,
      native_permission: false,

      image_url: null,
      loading_files: false,
      loading_persons: false,
      loading_cases: false,
      loading_events: false,
      loading_projects: false,
      isOpenDropDown: false,
      shortened_name: "",
      srch_txt: "",
      sp_res: [],
      srch_spisi: [],
      srch_predmeti: [],
      srch_projects: [],
      srch_events_list: [],
      srch_events_list_private: [],
      search_filter: "1",
      res_osobe: [],
      notifications: [],
      avatar_image_key: 1,
      authToken: "",
      avatar_class: null,
      search_open: false,
      admin_panel_acces: false,

      // Controll visibility
      visibility_controll: true,

      main_email_visible: false,
      unread_email_count: 0,
      email_refresh_interval: null,
      email_initial_timeout: null,
      is_fetching_email_count: false,
      emails_read_in_session: false,

      timeout: setTimeout(function () { }, 0),
      drop_items: [
        {
          id: "1",
          naziv: this.$t("components.nav_top.filter[0].text"),
          visible: true,
        },
        {
          id: "2",
          naziv: this.$t("components.nav_top.filter[1].text"),
          visible: true,
        },
        {
          id: "3",
          naziv: this.$t("components.nav_top.filter[2].text"),
          visible: true,
        },
        {
          id: "4",
          naziv: this.$t("components.nav_top.filter[3].text"),
          visible: true,
        },
        {
          id: "5",
          naziv: this.$t("components.nav_top.filter[4].text"),
          visible: true,
        },
        {
          id: "6",
          naziv: this.$t("components.nav_top.filter[5].text"),
          visible: true,
        },
        {
          id: "7",
          naziv: this.$t("components.nav_top.filter[6].text"),
          visible: false,
        },
        {
          id: "8",
          naziv: this.$t("components.nav_top.filter[7].text"),
          visible: false,
        },
      ],
    };
  },

  async created() {
    if (this.$route.fullPath.startsWith("/case/")) {
      this.search_filter = "7";
      this.drop_items[6].visible = true;
    } else if (
      this.$route.fullPath.startsWith("/projects/") &&
      this.$route.params.uid != undefined
    ) {
      this.search_filter = "8";
      this.drop_items[6].visible = false;
      this.drop_items[7].visible = true;
    } else {
      this.search_filter = "1";
      this.drop_items[6].visible = false;
      this.drop_items[7].visible = false;
    }
    // this.shortened_name =
    //   this.user.account.name.split(" ")[0][0] + "" + this.user.account.name.split(" ")[1][0];
    // this.authToken = this.$store.state.aToken
  },
  mounted() {
    this.setupExitConfirmation();
    // click outside listener na dokumentu i ako je kliknuto izvan dropdowna ugasi
    //mozda ima bolji nacin
    if (Notification.permission != "granted") {
      Notification.requestPermission();
    }

    // Fetch unread email count after initial page load (delayed to not slow down load)
    this.email_initial_timeout = setTimeout(() => {
      this.fetchUnreadEmailCount();
    }, 3000); // 3 second delay after mount

    // Refresh every 5 minutes
    this.email_refresh_interval = setInterval(() => {
      this.fetchUnreadEmailCount();
    }, 5 * 60 * 1000); // 5 minutes
    var _this = this;
    $(document).click(function (e) {
      if (
        _this.isOpenDropDown &&
        !$(e.target).is(
          "#dropdown-identificator, #dropdown-identificator *, .top-user-menu, .top-user-menu *"
        )
      ) {
        _this.isOpenDropDown = false;
      }
      if (
        _this.$refs.taskDrop.isOpenTaskDrop &&
        !$(e.target).is(".top-tasks, .top-tasks *, .top-tasks-menu")
      ) {
        _this.$refs.taskDrop.isOpenTaskDrop = false;
      }
      if (
        _this.$refs.sysDrop.isOpenTaskDrop &&
        !$(e.target).is(".top-tasks, .top-tasks *, .top-tasks-menu")
      ) {
        _this.$refs.sysDrop.isOpenTaskDrop = false;
      }
      if (
        _this.search_open &&
        !$(e.target).is(
          ".top-search, .top-search *, .dropdown-search-wrapper, .dropdown-search-wrapper *"
        )
      ) {
        _this.srch_txt = "";
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.confirmExit);
    // Clear email timers
    if (this.email_initial_timeout) {
      clearTimeout(this.email_initial_timeout);
    }
    if (this.email_refresh_interval) {
      clearInterval(this.email_refresh_interval);
    }
  },
  destroyed() {
    // $(document).off();
  },
};
</script>

<style></style>
